import React from 'react';
import { ChannelConnectionProps } from '../ChannelConnection';
import { useCurrentStateByControlUnitId } from '../../../../../../redux/controlUnit/hooks/useCurrentStateByControlUnitId';
import { useShowErrorMessage } from '../../../../../../handlingErrors';
import { getPolyglot } from '../../../../../../i18n';
import { getDigitalEventValue } from '../../../../../../redux/monitoring/api/util/mapDigitalEvent';
import { DEFAULT_VALUE_SENSOR } from '../../../../../../redux/controlUnit/api/util/constants';

function useChannelEvent(props: ChannelConnectionProps) {
  const { channel } = props;
  const showErrorMessage = useShowErrorMessage();
  const polyglot = getPolyglot();
  const {
    channel: channelId = '',
    controlUnitId = '',
    deviceId: commanderId = '',
  } = channel || {};

  const { currentEvents, loading, cloudConnectivity } =
    useCurrentStateByControlUnitId(
      commanderId,
      controlUnitId,
      showErrorMessage
    );

  const event = currentEvents?.[channelId];
  const eventValue = event?.value;
  const eventString = !cloudConnectivity
    ? DEFAULT_VALUE_SENSOR
    : typeof eventValue === 'string'
    ? getDigitalEventValue(eventValue, event?.metadata)
      ? polyglot.t('general.on')
      : polyglot.t('general.off')
    : DEFAULT_VALUE_SENSOR;
  return {
    value: eventValue,
    valueString: eventString,
    type: event?.metadata?.type,
    loading: loading && eventValue == undefined,
    event: event,
    error: event?.state !== 0,
    name: channel?.name,
  };
}

export default useChannelEvent;
